import { Component } from "solid-js";

const TermsOfUse: Component = () => {
  return (
    <>
      <h1 class="text-xl">Terms Of Use</h1>
      <p>...</p>
    </>
  );
};

export default TermsOfUse;
